import {Component} from "@angular/core";
import {RouteConfig, RouteDefinition} from "@angular/router-deprecated";
import {BlankComponent} from "../shared/blank/component";
import {NgForComponent} from "./ngfor/component";
import {NgSwitchComponent} from "./ngswitch/component";
import {NgClassComponent} from "./ngclass/component";
import {NgIfComponent} from "./ngif/component";
import {NgStyleComponent} from "./ngstyle/component";
import {NgFormTemplateComponent} from "./ngform-template/component";
import {NgFormModelComponent} from "./ngform-model/component";
import {NgFormBuilderComponent} from "./ngform-builder/component";
import {ValidatorsComponent} from "./validators/component";
import {I18nPluralPipeComponent} from "./i18npluralpipe/component";
import {I18nSelectPipeComponent} from "./i18nselectpipe/component";
import {I18nPluralComponent} from "./i18nplural/component";
import {LocationComponent} from "./location/component";
import {NgTemplateOutletComponent} from "./ngtemplateoutlet/component";

const ROUTES: Array<{ name: string; component: any }> = [
  { component: NgForComponent, name: "NgFor" },
  { component: NgSwitchComponent, name: "NgSwitch" },
  { component: NgClassComponent, name: "NgClass" },
  { component: NgIfComponent, name: "NgIf" },
  { component: NgStyleComponent, name: "NgStyle" },
  { component: NgFormTemplateComponent, name: "NgFormTemplate" },
  { component: NgFormModelComponent, name: "NgFormModel" },
  { component: NgFormBuilderComponent, name: "NgFormBuilder" },
  { component: ValidatorsComponent, name: "Validators" },
  { component: LocationComponent, name: "Location" },
  { component: I18nPluralPipeComponent, name: "I18nPluralPipe" },
  { component: I18nSelectPipeComponent, name: "I18nSelectPipe" },
  { component: I18nPluralComponent, name: "I18nPlural" },
  { component: NgTemplateOutletComponent, name: "NgTemplateOutlet" },
];

@Component({
  selector: "common-root",
  template: `
<module-root name="Common" [routes]="routes"></module-root>
  `
})
@RouteConfig(
  ROUTES.map<RouteDefinition>(route => {
    return <RouteDefinition>{
      path: `/${route.name.toLowerCase()}`,
      component: route.component,
      name: route.name,
    };
  }).concat({ path: "/", component: BlankComponent, useAsDefault: true })
)
export class CommonRoot {
  private routes = ROUTES;
}



/** WEBPACK FOOTER **
 ** ./script/common/root.component.ts
 **/